import React, { useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { css } from '@emotion/react';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import { setCustomNameToText } from '@service/ChapterService';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';
import theme from '@styles/theme';

interface IChoiceImageItem {
  choiceName?: string;
  choiceImageUrl: string;
}

const ChoiceImageItem = ({
  choiceName,
  choiceImageUrl,
  onClickItem,
}: IChoiceImageItem & {
  onClickItem: () => void;
}) => {
  return (
    <div css={choiceItem} onClick={onClickItem}>
      <img className="image-box" src={choiceImageUrl} alt="Toast image" />
      {choiceName && <div className="text-box">{choiceName}</div>}
    </div>
  );
};

const ChoiceImageList = () => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const { choice, onChoice } = useChatPlayContext();
  const [choiceItems, setChoiceItems] = useState<IChoiceImageItem[]>();

  useEffect(() => {
    const choices = choice?.choices;
    const choiceImageUrls = choice?.options?.choiceImageUrls;

    if (choiceImageUrls && playChapterInfo) {
      const items = choiceImageUrls.map((url, index) => {
        return {
          choiceName: setCustomNameToText({
            text: choices?.[index] || '',
            playChapterInfo,
          }),
          choiceImageUrl: url,
        };
      });
      setChoiceItems(items);
    }
  }, [choice]);

  return (
    <div css={container}>
      {choiceItems?.map((item, index) => (
        <ChoiceImageItem
          key={item.choiceImageUrl}
          choiceName={item.choiceName}
          choiceImageUrl={item.choiceImageUrl}
          onClickItem={() =>
            onChoice({
              choiceName: choice?.choiceName || '',
              choiceItem: {
                choiceIndex: index,
                selectedName: item.choiceName || '',
              },
            })
          }
        />
      ))}
    </div>
  );
};

const container = css`
  height: 100%;
  width: 100%;
  margin: auto;
  overflow-x: auto;
  padding: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 1em;

  &::before,
  &::after {
    content: '';
    flex: 1;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;

const choiceItem = css`
  background-color: ${theme.colors.gray900};
  border-radius: 4px;
  padding: 12px;
  /* flex: 1; */

  .image-box {
    width: 110px;
    height: 110px;
    border-radius: 4px;
    object-fit: cover;
  }

  .text-box {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-all;
    text-align: center;
    max-width: 110px;
    margin-top: 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: ${theme.colors.white};
  }
`;

export default ChoiceImageList;
